import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.title',
    defaultMessage: 'Settings',
    description: 'title of the configuration page',
  },
  alert: {
    message: {
      id: 'pages.settings.alert.message',
      defaultMessage:
        "These are global settings that are used as defaults. If you want to change the settings of a specific client, open it on the 'Clients' page.",
      description: 'message in the alert on the settings page',
    },
  },
  subNavigation: {
    general: {
      id: 'pages.settings.subNavigation.general',
      defaultMessage: 'General',
      description: 'label of the general tab on the settings page',
    },
    developerSettings: {
      id: 'pages.settings.subNavigation.developerSettings',
      defaultMessage: 'Developer settings',
      description: 'label of the developer settings tab on the settings page',
    },
  },
};

export default defineMessages(translations);
